import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Download04 = function Download04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m8 12 4 4m0 0 4-4m-4 4V6.8c0-1.3907 0-2.086-.5505-2.8646-.3658-.5173-1.4189-1.1557-2.0467-1.2408-.945-.128-1.3037.0592-2.0214.4335C4.1834 4.7964 2 8.1432 2 12c0 5.5228 4.4772 10 10 10s10-4.4772 10-10c0-3.7014-2.011-6.9331-5-8.6622"
    })
  }));
};
export default Download04;